import { createAction, props } from '@ngrx/store';
import { ErrorResponse, IGenericError } from '../../../../src/app/core/models/generic-models';
import { IStaticDataCountriesResponse } from '../models/static-data-countries.model';

export const loadStaticDataCountriesForSettings = createAction('[StaticDataCountriesForSettings] Load StaticDataCountriesForSettings');

export const loadStaticDataCountriesForSettingsSuccess = createAction(
  '[StaticDataCountriesForSettings] Load StaticDataCountriesForSettings Success',
  props<{ response: IStaticDataCountriesResponse[] }>()
);

export const loadStaticDataCountriesForSettingsFailure = createAction(
  '[StaticDataCountriesForSettings] Load StaticDataCountriesForSettings Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);
